function getDecodedToken(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (error) {
    return {};
  }
}
export { getDecodedToken };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/one-auth-sdk/dist/esm/utils/jwtDecoder.js
// module id = 1613
// module chunks = 11